import { gatewayConstants } from '../constants';
import { gatewayService } from '../../services';

export const gatewayActions = {
  gatewaysList,
  addGateway,
  getGateway,
  updateGateway,
};

/*
ACTION: Gateways List
*/
function gatewaysList(addToast, pageID, perPage) {
  return (dispatch) => {
    dispatch(request());
    return gatewayService.gatewaysList(pageID, perPage).then(
      (response) => {
        dispatch(success(response.data.body.items, response.data.body.total));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: gatewayConstants.GETALL_REQUEST };
  }
  function success(items, total) {
    return { type: gatewayConstants.GETALL_SUCCESS, items, total };
  }
  function failure(error) {
    return { type: gatewayConstants.GETALL_FAILURE, error };
  }
}

/*
ACTION: Add Gateway
*/
function addGateway(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return gatewayService.addGateway(formData).then(
      (response) => {
        addToast('عملیات با موفقیت انجام شد.', { appearance: 'success', autoDismiss: true });
        dispatch(success(true));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: gatewayConstants.ADD_REQUEST };
  }
  function success(status) {
    return { type: gatewayConstants.ADD_SUCCESS, status };
  }
  function failure(error) {
    return { type: gatewayConstants.ADD_FAILURE, error };
  }
}

/*
ACTION: Get Gateway By ID
*/
function getGateway(addToast, gatewayID) {
  return (dispatch) => {
    dispatch(request());
    return gatewayService.getGateway(gatewayID).then(
      (response) => {
        dispatch(success(response.data.body));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: gatewayConstants.GET_REQUEST };
  }
  function success(item) {
    return { type: gatewayConstants.GET_SUCCESS, item };
  }
  function failure(error) {
    return { type: gatewayConstants.GET_FAILURE, error };
  }
}

/*
ACTION: Update Gateway
*/
function updateGateway(addToast, formData) {
  return (dispatch) => {
    dispatch(request());
    return gatewayService.updateGateway(formData).then(
      (response) => {
        addToast('بروزرسانی با موفقیت انجام شد.', { appearance: 'success', autoDismiss: true });
        dispatch(success(true));
      },
      (error) => {
        if (typeof error === 'object') {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: 'error', autoDismiss: true });
          });
        } else {
          addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: gatewayConstants.UPDATE_REQUEST };
  }
  function success(status) {
    return { type: gatewayConstants.UPDATE_SUCCESS, status };
  }
  function failure(error) {
    return { type: gatewayConstants.UPDATE_FAILURE, error };
  }
}
